/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from "react";
import "./Auth.css";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const ConfirmEmail = () => {
  const [formData, setFormData] = useState({
    email: ""
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const history = useHistory();

  const [timer, setTimer] = useState(10);

  const timerRef = useRef(); 
 
  const fetchData = async() => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}api/auth/confirm?verifyToken=${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();
    
      if (!response.ok) {
        throw new Error(data.message || "Verification failed");
      }
      setLoading(false);

      handleTimeoutAndRedirect();

    } catch (err) {
      setError(err.message);
    }
  };

  const handleTimeoutAndRedirect = () => {
    timerRef.current = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
        // When the timer reaches zero (or below), redirect and clear the interval
          history.push("/login");
          clearInterval(timerRef.current);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    fetchData();
    // handleTimeoutAndRedirect();
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
    
  return (
    <div className="auth-container">
      <div className="auth-box auth-info">
        {loading && "Loading..."}
        {error && <div>{error}</div>}
        {!loading && !error && <>
          <p><b>Your account has been successfully activated!</b></p>
          <br />
          <p> You will be redirected to the login page in <b>{timer}</b> seconds.<br />
          If the redirection doesn't happen automatically, please click the button below.</p>
          <br />
          <Link to="/login">Login</Link>
        </>}
      </div>
    </div>
  );
};

export default ConfirmEmail; 
